import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Landing from "@/pages/Landing";
import AppShell from "@/components/layout/AppShell";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import InvoiceForm from "@/pages/InvoiceForm";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Customers from "@/pages/Customers";
import Vendors from "@/pages/Vendors";
import Products from "@/pages/Products";
import GstReturns from "@/pages/GstReturns";
import BankRecon from "@/pages/BankRecon";
import Reports from "@/pages/Reports";
import Vouchers from "@/pages/Vouchers";
import AuditLogs from "@/pages/AuditLogs";
import CompanySetup from "@/pages/CompanySetup";
import Purchases from "@/pages/Purchases";
import Expenses from "@/pages/Expenses";
import CreditNotes from "@/pages/CreditNotes";
import ChartOfAccounts from "@/pages/ChartOfAccounts";
import Team from "@/pages/Team";
import Subscription from "@/pages/Subscription";
import Settings from "@/pages/Settings";
import GspConfig from "@/pages/GspConfig";
import Recurring from "@/pages/Recurring";
import Agency from "@/pages/Agency";
import TravelExpense from "@/pages/TravelExpense";
import Erp from "@/pages/Erp";
import Payroll from "@/pages/Payroll";
import Manufacturing from "@/pages/Manufacturing";
import ApprovalRules from "@/pages/ApprovalRules";
import Help from "@/pages/Help";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-sm text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/app" element={<Protected><AppShell /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="company-setup" element={<CompanySetup />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="invoices/new" element={<InvoiceForm />} />
        <Route path="invoices/:id" element={<InvoiceDetail />} />
        <Route path="customers" element={<Customers />} />
        <Route path="vendors" element={<Vendors />} />
        <Route path="products" element={<Products />} />
        <Route path="gst-returns" element={<GstReturns />} />
        <Route path="bank-recon" element={<BankRecon />} />
        <Route path="reports" element={<Reports />} />
        <Route path="vouchers" element={<Vouchers />} />
        <Route path="purchases" element={<Purchases />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="credit-notes" element={<CreditNotes />} />
        <Route path="chart-of-accounts" element={<ChartOfAccounts />} />
        <Route path="team" element={<Team />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="settings" element={<Settings />} />
        <Route path="gsp-config" element={<GspConfig />} />
        <Route path="recurring" element={<Recurring />} />
        <Route path="agency" element={<Agency />} />
        <Route path="tne" element={<TravelExpense />} />
        <Route path="erp" element={<Erp />} />
        <Route path="payroll" element={<Payroll />} />
        <Route path="manufacturing" element={<Manufacturing />} />
        <Route path="approval-rules" element={<ApprovalRules />} />
        <Route path="help" element={<Help />} />
        <Route path="audit-logs" element={<AuditLogs />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
